import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Card,
  Typography,
  Stack,
  Container,
  Skeleton,
  Avatar,
  useTheme,
} from "@mui/material";
import {
  PeopleAlt,
  HowToReg,
  PersonOff,
  TrendingUp,
} from "@mui/icons-material";
import { useSelector } from "react-redux";
import configServ from "../services/config";
import { useNavigate } from "react-router-dom";
import AttendanceChart from "../Components/Chart/AttendanceChart";
import PunchLogsDashboard from "../Components/Chart/PunchLogsDashboard";

const Dashboards = () => {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [sampleData, setSampleData] = useState(null);
  const [currentWorkingEmployees, setCurrentWorkingEmployees] = useState(null);
  const theme = useTheme();
  const navigate = useNavigate();
  const { user_id, company_id } = useSelector((state) => state.GlobalVariables);

  const fetchDashboardData = async () => {
    setLoading(true);
    try {
      const response = await configServ.getHrDashboardData({ company_id: 1 }); // Aapka API call
      if (response.status) {
        setStats(response.data);
      }
    } catch (error) {
      console.error("Dashboard Error:", error);
    } finally {
      setTimeout(() => setLoading(false), 800); // Smooth feel ke liye
    }
  };

  const fetchAttendanceChartData = async () => {
    try {
      const result = await configServ.getAttendanceChart({ user_id, company_id, filter: "last_7_days" });
      setSampleData(result);
    } catch (e) {
      console.log(e);
    }
  };

  const fetchCurrentWorkingEmployeesData = async () => {
    try {
      const result = await configServ.currentWorkingEmployees({ user_id, company_id, filter: "last_7_days" });
      setCurrentWorkingEmployees(result);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    fetchDashboardData();
    fetchAttendanceChartData();
    fetchCurrentWorkingEmployeesData();
  }, []);

  // Future-proof Array: Nayi cheezein yahan add karein
  const dashboardWidgets = [
    {
      title: "Total Employees",
      value: stats?.total_employees || 0,
      icon: <PeopleAlt sx={{ fontSize: 32 }} />,
      color: "#1976d2",
      bg: "#e3f2fd",
      path: '/employeepro/employee', // Future proof path
    },
    {
      title: "Present Today",
      value: stats?.present_today || 0,
      icon: <HowToReg sx={{ fontSize: 32 }} />,
      color: "#2e7d32",
      bg: "#e8f5e9",
      path: '/employeepro/attendance', // Future proof path
    },
    {
      title: "Absent Today",
      value: stats?.absent_today || 0,
      icon: <PersonOff sx={{ fontSize: 32 }} />,
      color: "#d32f2f",
      bg: "#ffebee",
      path: '/employeepro/attendance', // Future proof path
    },
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      {/* <Box sx={{ mb: 4 }}>
        <Typography variant="h4" sx={{ fontWeight: 800, color: "#1a237e" }}>
          Admin Dashboard
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Welcome back! Here's what's happening today.
        </Typography>
      </Box> */}

      <Grid container spacing={3}>
        {loading
          ? // Skeleton Loaders while fetching
            [1, 2, 3].map((item) => (
              <Grid item xs={12} sm={6} md={4} key={item}>
                <Skeleton
                  variant="rounded"
                  height={140}
                  sx={{ borderRadius: 4 }}
                />
              </Grid>
            ))
          : // Actual Dynamic Widgets
            dashboardWidgets.map((widget, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  onClick={() => navigate(widget.path)}
                  sx={{
                    p: 3,
                    borderRadius: 4,
                    boxShadow: "0 4px 20px rgba(0,0,0,0.05)",
                    transition: "0.3s",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "translateY(-5px)",
                      boxShadow: "0 8px 25px rgba(0,0,0,0.1)",
                    },
                    border: `1px solid ${widget.bg}`,
                  }}
                >
                  <Stack
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Box>
                      <Typography
                        variant="overline"
                        sx={{ fontWeight: "bold", color: "text.secondary" }}
                      >
                        {widget.title}
                      </Typography>
                      <Typography variant="h3" sx={{ fontWeight: 800, my: 1 }}>
                        {widget.value}
                      </Typography>
                    </Box>
                    <Avatar
                      sx={{
                        bgcolor: widget.bg,
                        color: widget.color,
                        width: 60,
                        height: 60,
                        borderRadius: 3,
                      }}
                    >
                      {widget.icon}
                    </Avatar>
                  </Stack>

                  {/* <Stack
                    direction="row"
                    alignItems="center"
                    spacing={0.5}
                    sx={{ mt: 2 }}
                  >
                    <TrendingUp sx={{ fontSize: 16, color: widget.color }} />
                    <Typography
                      variant="caption"
                      sx={{ color: widget.color, fontWeight: "bold" }}
                    >
                      Live Updating
                    </Typography>
                  </Stack> */}
                </Card>
              </Grid>
            ))}
      </Grid>

      {/* Attendance chart + Live punch logs */}
      <Grid container spacing={3} sx={{ mt: 0.5 }}>
        <Grid item xs={12} md={6}>
          <Box sx={{ height: "100%" }}>
            <AttendanceChart apiResponse={sampleData} />
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box sx={{ height: "100%" }}>
            <PunchLogsDashboard apiResponse={currentWorkingEmployees} />
          </Box>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Dashboards;